import React, { Component, ContextType, ReactElement } from 'react';

import { Route as ReactRoute } from 'react-router-dom';

import { RouteAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { ContainerProvider } from '@philips-emr/tws-core/lib/component';
import { RouteContext } from '@philips-emr/tws-core/lib/component/context';
import { arrayOf, bool, element, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { listenHistoryChange, setMatch } from '@philips-emr/tws-core/lib/services/history-service';
import { isFunction } from '@philips-emr/tws-utils';

const acceptedTypes = [
  ComponentType.LAYOUT,
];

export interface RouteProps {
  children: ReactElement | ReactElement[];
  exact?: boolean;
  route: string;
  uuid?: string;
}

@AwesomeComponent({ name: 'Route', type: ComponentType.BEHAVIOR, api: RouteAPI })
class Route extends Component<RouteProps> {
  static contextType = RouteContext.Context;

  context!: ContextType<typeof RouteContext.Context>;

  unlisten: Function | null = null;

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    exact: bool,
    route: string,
    uuid: string,
  };

  componentDidMount(): void {
    this.unlisten = listenHistoryChange(() => this.forceUpdate());
  }

  componentWillUnmount(): void {
    if (isFunction(this.unlisten)) {
      this.unlisten();
    }
  }

  render(): ReactElement | null {
    const { children, exact, uuid } = this.props;

    const Container = ContainerProvider.provide(this);

    if (!Container) {
      return null;
    }

    if (uuid && React.Children.count(children) === 0) {
      return <Container acceptedTypes={acceptedTypes} className="u-expand" uuid={uuid} />;
    }

    const context = this.context.nestedContext(this.props.route);
    const route = context.get();

    return (
      <ReactRoute exact={exact} path={route} render={(props) => {
        setMatch(props.match);

        return (
          <RouteContext.Context.Provider value={context}>
            {children}
          </RouteContext.Context.Provider>
        );
      }}
      />
    );
  }
}

export default Route;
